// extracted by mini-css-extract-plugin
export default {"root":"JeA59evT8I","list":"SD6cpC6UQg","list_showAll":"CO5RcyvTLE","item":"kxUb2qtUCe","item_hidden":"lq06qNy75K","attachmentButtons":"wD6eqBGSpD","showMoreBlock":"lRdJbdwOzo"};